"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isParticipatingDisciplinesProperty = exports.participatingDisciplinesPropertyDefinition = void 0;
exports.participatingDisciplinesPropertyDefinition = {
    view: {
        label: 'Participating disciplines',
        hint: 'Which disciplines describe this person best? Get as granular as possible.',
    },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
    ],
    type: 'text',
    multiple: true,
    name: 'participating-disciplines',
};
const isParticipatingDisciplinesProperty = (prop) => {
    return prop.name === exports.participatingDisciplinesPropertyDefinition.name;
};
exports.isParticipatingDisciplinesProperty = isParticipatingDisciplinesProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFydGljaXBhdGluZy1kaXNjaXBsaW5lcy5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3BhcnRpY2lwYXRpbmctZGlzY2lwbGluZXMucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSwwQ0FBMEMsR0FBRztJQUN4RCxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsMkJBQTJCO1FBQ2xDLElBQUksRUFBRSwyRUFBMkU7S0FDbEY7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxJQUFJO1NBQ2Y7S0FDRjtJQUNELElBQUksRUFBRSxNQUFNO0lBQ1osUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsMkJBQTJCO0NBQ0YsQ0FBQTtBQUkxQixNQUFNLGtDQUFrQyxHQUFHLENBQUMsSUFBa0IsRUFBNEMsRUFBRTtJQUNqSCxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssa0RBQTBDLENBQUMsSUFBSSxDQUFBO0FBQ3RFLENBQUMsQ0FBQTtBQUZZLFFBQUEsa0NBQWtDLHNDQUU5QyJ9